var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_49_261",
    transform: "scale(0.00735294)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_49_261",
    width: 136,
    height: 136,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAYAAAA8uqNSAAAEPUlEQVR4nO3dT5IURRiG8fcjWHkBb9DDEXCHinADmGYDB3BpdCtKgLvpZgXqhIQi4J/p6dAwwhPIzg0HoJsTeAQMmWQBAwNOjz1VWZmVXz7PPqu+iP5FZXREd6VERERERERERERERERERERERJ6ythcYDzf+jDGIhyzYg63dx/ebrv9r/vF1sxM3Ys50+sLtVp/xyViDVJ+Fe1uzxY9Nl3eBI0YAiVAI4YfpbPlT0/V9xSEBJEZ3p7vLn5su7jMOCSCtCqbvpzuLX5qu7zsOCSDNC/bddPZ4p+nyEnBIAGmWhTuT2WK36fJScEjSidwDFJeFO5OdZRU4JJ4gx2ovhG9vzpbzputLwyEBZO3MtH1ztvy16foScUhsMWtlpu2tnUV1OCSeIEdnCmFP25PZ4remlygZhwSQ1ZlCeLb39XT+5Pemlygdh8QWc3jgeBVA3s4UbC98BY4XscUczBT0TLe25ss/ml7CEw6pB0Ams8X7uWeIlTccEltMtDzikAASJa84JIC0zjMOCSCt6juOEPRl22sApGEl4Hjv4u3W8wGkQbXgkABy7GrCIQHkWNWGQwLI2tWIQwLIWtWKQwLI/1YzDgkgR1Y7DgkgKwPHiwBySOB4HUDeChxvBpADgeO/AeRl4Dg8gAgcR1U9EOc4Wn++VQPxjmM8HIzazlAtEO84RsPBWLLzbeeoEkgNOEx2LsYs1QEBx/HK/r+YlHnHMb506lOF8FHMmaoB4h3HaLjxmUI4G3UoVbLF1IDDpOg4pAqeIN5xjDc3rkr6MOZMb9ygqwv3oSpwWHc4JMdAwBEnl1uMdxyjSxufK+iDqEOtyB0Q7zjGw8EXCkr2ygxXW0wVOGRJ36fiBgg4usnFFuMdx2hzcE2yM1GHWvfmOW4aM+c4bLQ5uGaWB4eUGYgFe9BmvXMc+uTcu+/kxCHl3GKcnvG2X86fCcYsCxDPZ7xJfnBIeYC4PuPNEw4pMRDvZ7x5wyGlBOL8jDePOKRUQJyf8eYVh5Tia67zM94845A6foJ4P+PNOw6pQyDez3irAYfU0Rbj/Yy3WnBIsYGYQgj6BhxxevTP309T3Oeo4gHZP8Zr1+8BgKmfHA8f6t9U91pVHCAVnPFW07ZysPZAKjjjrVYcUoxvMc7PeKsZhxThCTKZL8DhuGw/GAJHGWUBAo5ySg4EHGWVFAg4yisZEHCUWRIg4Ci3zoGAo+w6BQKO8usMCDh81AkQcPgpOhBw+CoqEHD4KxoQcPgsChBw+K01EHD4rjUQcPiu+DcMrQoccXIJBBzxcgcEHHFz8ZbD/driGA0Hl012JeZMpefmCQKObnIBBBzdVTwQcHRb0UDA0X3FAgFHmooEAo50FQcEHGkrCgg40lcMEHDkqQgg4MhX74GAI2+9BgKO/PUWCDj6US+BgKM/9Q4IOIiIiIiIiIiIiIiIiIiIiIiIuus5mRA1QuLR09QAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMid);
export default __webpack_public_path__ + "static/media/Icon_Mid.411267f4abb3b5bf63c93cca543a2b17.svg";
export { ForwardRef as ReactComponent };